import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./LoginPage.css"; 
import FRONTEND_CONFIG from "./frontend_config";

const UserSignup_Page = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    role: "user",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (formData.password !== formData.confirmPassword) {
      return setError("Passwords do not match!");
    }

    try {
      const res = await axios.post(`${FRONTEND_CONFIG.API_URL}/api/user/register`, {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        role: formData.role,
      });

      if (res.status === 201 || res.status === 200) {
        setSuccess("🎉 Registration successful! Redirecting to login...");
        setTimeout(() => navigate("/user-login"), 2000);
      }
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message || "Registration failed. Try again.");
      } else {
        setError("Server not reachable. Please try again later.");
      }
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <div className="left-section">
          <h2>Sign Up</h2>

          <form onSubmit={handleSubmit}>
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />

            <label>Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />

            <label>Select Role</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
            >
              <option value="user">User</option>
              <option value="lecture">Lecture</option>
              <option value="examsection">Exam Section</option>
              <option value="admin">Admin</option>
            </select>

            {error && <p className="error-msg">{error}</p>}
            {success && <p className="success-msg">{success}</p>}

            <button type="submit" className="login-btn">
              Register
            </button>

            <p className="signup-text">
              Already have an account?{" "}
              <span onClick={() => navigate("/user-login")}>Login</span>
            </p>
          </form>
        </div>

        <div className="right-section">
          <h1>JOIN US</h1>
          <p>Create your account to access the Exam Portal</p>
        </div>
      </div>
    </div>
  );
};

export default UserSignup_Page;
